
import { address, email, mobile_no } from '../../constants/themeConstants'
import React,{useState} from 'react'
import {AiOutlineMail} from 'react-icons/ai'
import {IoMdCall} from 'react-icons/io'
import {IoLocationOutline} from 'react-icons/io5'
import {FiChevronRight} from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import ErrorComponent from '../../constants/ErrorComponent'
import toast from 'react-hot-toast'



function Contact() {

  const navigator = useNavigate()

  const [data,setdata] = useState({name:'',email:'',mobile:'',requirment:'',department_website:''})
  const [error,seterror] = useState({name:'',email:'',mobile:'',requirment:'',department_website:''})

  function handleChange(e){
    setdata({...data,[e.target.name]:e.target.value})
    seterror({...error,[e.target.name]:''})
  } 

  const branches = [
    {
      name:"Mumbai",
      location:"No.606/7 Sagartech Plaza B wing,Sakinaka Junction, Andheri-Kurla Road,Mumbai- 400072"
    },
    {
      name:"Chennai",
      location:"6/2, CASA Major Rd, Egmore,Chennai, Tamil Nadu 600008"
    },
    {
      name:"Pune",
      location:"Kothari Plaza,Bibwewadi-Kondwa, Rd,Lullanagar„ Pune, Maharashtra-411040"
    },
    {
      name:"Hyderabad",
      location:"No.2 Banjara Hills, Annapurna Studios Lane, Hyderabad, Telangana 500034"
    },
    {
      name:"Shivamogga",
      location:"Keonics IT Park, Machenahalli, Shivamogga, Karnataka 577222"
    },
    {
      name:"Kolkata",
      location:"Express Tower, 42A, Shakespeare Sarani Rd, Elgin, Kolkata, West Bengal 700017"
    },
    {
      name:"Ahmedabad",
      location:"Astron Tech Park, Satellite Rd,  Ahmadabad, Gujarat – 380015"
    }
  ]

  async function submitData() {
    if(!data.name){
      seterror({...error,name:'This Field is required*'})
    }else if(!data.mobile){
      seterror({...error,mobile:'This Field is required*'})
    }else if(!data.email){
      seterror({...error,email:'This Field is required*'})
    }else if(!data.requirment){
      seterror({...error,requirment:'This Field is required*'})
    }else{
      let sendData = {...data}
      // sendData['department_website'] = 'Corp Team'
      // const response = await axios.post(`https://fidelitustech.com/api/clients/create`,sendData)
      // // console.log("response",response?.data?.status)
      // if(response?.status == 201){
        toast.success("Your Request Submitted Successfully!")
        resetForm()
      // }
    }
  }

  function resetForm(){
    setdata({name:'',email:'',mobile:'',requirment:'',department_website:''})
    seterror({name:'',email:'',mobile:'',requirment:'',department_website:''})
  }

  return (
    <div className='w-screen bg-gray-50'>
      <div className="bg-banner10 flex items-center justify-center min-h-[200px] max-h-[200px] md:min-h-[300px] md:max-h-[300px] bg-cover bg-center">
        <h1 className="bg-[#7b026b]/30 z-10 w-max px-10 py-2 md:py-5 text-[16px] md:text-[20px] text-white uppercase font-heading">
          Contact Us
        </h1>
        <div className='bg-black/60 absolute w-full min-h-[200px] max-h-[200px] md:min-h-[300px] md:max-h-[300px]'>
        </div>
       </div> 

      <div className='w-[90%] md:w-[80%] mx-auto py-10'>
        <h1 data-aos="fade-left" className='text-[24px] 2xl:text-[27px] font_bold'>Contact Us</h1>
        <h1 data-aos="fade-right" className='text-[15px] 2xl:text-[17px] font_normal'>Visit our branch with the below mentioned address.</h1>
        

        <div className='md:flex shadow-sm bg-white mt-4'>
           
            <div data-aos="fade-right" className='md:w-[30%] mt-10 mb-10 md:mb-0'>

            <h6 className='pl-8 bg-gray-100 p-2 font_normal text-[16px] 2xl:text-[18px]'>Our Address</h6>    
            <div >
            <div  className='w-full h-full flex  items-start mt-4 md:border-r pr-4 pl-4'>
            <IoLocationOutline color='#4190ac' size={30} />
            <h6 className='text-[15px] 2xl:text-[16px] font_normal cursor-pointer pl-2'>{address}</h6>
            </div>
           
          

            <div  data-aos-delay="400" className='w-full h-full flex  items-start mt-4 md:border-r pr-4 pl-4'>
            <IoMdCall color='#4190ac' size={15} />
            <h6 className='text-[15px] 2xl:text-[16px] font_normal cursor-pointer  pl-2'>{mobile_no}</h6>
            </div>

            <div className='w-full h-full flex  items-start mt-4 pr-4 pl-4'>
            <AiOutlineMail color='#4190ac' size={15}/>
            <h6 className='ml-1 text-[15px] 2xl:text-[16px] font_normal cursor-pointer  pl-2'>{email}</h6>
            </div>
            </div>
            </div>


            <div data-aos="fade-left"  className=' md:w-[70%] '>
            <div className='w-[100%]'>
             <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31101.390151879834!2d77.48972897431642!3d12.992705500000016!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3dba0415e1a5%3A0x6b9543113e2821ff!2sImmanuel%20Gospel%20Prayer%20House%20(Church)!5e0!3m2!1sen!2sin!4v1762623501747!5m2!1sen!2sin" className='w-full' height="400"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
            </div>
        </div>


        {/* <h1 data-aos="fade-left" className='text-[24px] mt-10 2xl:text-[27px] font_bold'>Our Branchs</h1>

        <div className='bg-white shadow-sm  p-5 mt-5'>
            <h6 className='text-[14px] 2xl:text-[17px] font_normal pl-6 mt-4'>Magdi | Kamalanagar | Nandhini Layout | Ullal Uppanagar | Kalanakuppe | Ashwath Nagar | Doddabalpur | Ashrayanagar | Belalam</h6>
            <h6 className='text-[14px] 2xl:text-[17px] font_normal pl-6 mt-4'></h6>
        </div> */}

        <h6 data-aos="fade-left"  className='font_bold text-[21px] 2xl:text-[22px] flex mt-10'> <span className='min-w-[4px] block min-h-[4px] max-h-[21px] rounded mt-[2.5px] mr-4 bg-[#7b026b]'></span>Write to Us</h6>
        <h1 data-aos="fade-right"  className='text-[16px] 2xl:text-[17px] font_normal pl-6 mt-4'>Simply fill out the form below, and we’ll get back to you shortly. Let’s connect and pray together!
        </h1>

        <div data-aos="fade-up"  className='bg-white shadow-sm  p-5 mt-5'>
        <div className='md:flex'>
        <div className='md:mr-2 w-full'>
        <div className='mb-4'>
        <input type='text' name="name" placeholder='Name' value={data?.name} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-2 pl-2 text-[13px] 2xl:text-[16px]' />
        <ErrorComponent error={error?.name} />
        </div>
        <div className='mb-4'>
        <input type='text' name="mobile" placeholder='Contact Number' value={data?.mobile} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-2 pl-2 text-[13px] 2xl:text-[16px]' />
        <ErrorComponent error={error?.mobile} />
        </div>
        <div className='mb-4'>
        <input type='text' name="email" placeholder='Email' value={data?.email} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-2 pl-2 text-[13px] 2xl:text-[16px]' />
        <ErrorComponent error={error?.email} />
        </div>

        </div>    
        <div className='md:ml-2 mb-4 w-full'>
        <textarea type='text' name="requirment" placeholder='Query' value={data?.requirment} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-2 pl-2 text-[13px] 2xl:text-[16px]' />
        <ErrorComponent error={error?.requirment} />
        </div>

        </div> 

       
        <div onClick={submitData} className='flex w-full mt-2 md:mt-0 items-center justify-end'>
        <h6 className='bg-gray-100 cursor-pointer transition-all duration-500 w-max md:w-[80px] text-[14px] 2xl:text-[17px] text-center px-2 py-2 font_normal hover:bg-black hover:text-white'>Submit</h6>
        </div>
        </div>


      </div>   
    </div>
  )
}

export default Contact